<script>
    import { createEventDispatcher } from 'svelte'
    import moment from 'moment'

    import Modal from '../../components/Modal/Modal.svelte'
    import ModalOverlay from '../../components/Modal/ModalOverlay.svelte'
    import ListClients from './ListClients.svelte'
    // import SveltePerfectScrollbar from '../../components/SveltePerfectScrollbar/SveltePerfectScrollbar.svelte'
    import ListField from './ListField.svelte'
    import ListOperators from './ListOperators.svelte'
    import ListWorks from './ListWorks.svelte'
    import ListAreas from './ListAreas.svelte'
    import SmartField from '../../components/SmartField/SmartField.svelte'
    import SmartSelect from '../../components/SmartField/SmartSelect.svelte'
    import ChooseDate from './ChooseDate.svelte'
    import userStore from '../../stores/user'
    import SideListEditorLayout from '../../components/SideListEditorLayout/SideListEditorLayout.svelte'
    

    export let data
    export let create = false
    export let users
    
    let ctrlsDisabled = false,
        listModel = null,
        listType = 'datepicker',
        clients = [],
        operatorsMap = {},
        types = [
            { value: '0', text: 'Ordinario' }, 
            { value: '1', text: 'Straordinario' }
        ],
        viewDefaults = {
            client: 'Scegli cliente',
            operators: 'Scegli operatore/i',
            zone: 'Scegli Area/Indirizzo'
        },
        validFields = {
            client: true,
            operators: true
        },
        view = {
            client: viewDefaults.client,
            operators: viewDefaults.operators,
            zone: viewDefaults.zone
        },
        areas = null,
        initialModel = '',
        model = {
            category: $userStore.sector.id,
            date: "",
            client: "",
            zone: "",
            description: "",
            operators: "",
            type: "1",
            notes: ""
        },
        dateValue = moment().set('hours', 7).set('minutes', 0).toDate (),
        dateString = '';

    const dispatch = createEventDispatcher ();
    
    const save = (event) => {
        if (validateModel ()) {
            ctrlsDisabled = true;
            dispatch ('save', {
                data: model,
                previous: data
            })
        }
    }

    const cancel = (event) => {
        ctrlsDisabled = true;
        dispatch ('cancel', {
            data: data
        })
    }

    const validateModel = () => {
        validFields.client = model.client !== ''
        validFields.operators = model.operators !== ''

        console.log ('validFields', validFields)

        return validFields.client && validFields.operators;
    }

    const loadData = () => {
        // console.log ('load data', data);
        if (data.category)
            model.category = data.category;
        if (data.date) {
            model.date = data.date;
            dateValue = new Date (model.date)
        }

        if (data.client)
            model.client = data.client;
        if (data.zone)
            model.zone = data.zone;
        if (data.description)
            model.description = data.description;
        if (data.operators)
            model.operators = data.operators;
        if (data.type !== undefined)
            model.type = data.type.toString();
        if (data.notes)
            model.notes = data.notes;

        if (data.data) {
            try {
                const obj_data = typeof (data.data) === 'string' ? JSON.parse (data.data) : data.data;
                if (obj_data.address) {
                    areas = data.client_data.address.length > 1 ? data.client_data.address : null;
                    model.data = JSON.stringify (obj_data)
                    view.zone = obj_data.address.name + ' (' + obj_data.address.city + ')';
                }
            } catch (e) {
                console.log ('parsing error', e)
            }
        }

        if (data.client_data)
            view.client = data.client_data.name;
        if (data.oprts)
            view.operators = data.oprts.map (it => {
                const { name, token_id } = it
                return {
                    name,
                    token_id
                }
            })

        toOpsMap ();
        initialModel = create ? '' : JSON.stringify (model)
    }

    const toOpsMap = () => {
        operatorsMap = Object.assign ({ }, ...view.operators.map (s => ({[s.token_id]: s})));
        // console.log ('toOpsMap', operatorsMap)
    }

    const toOpsList = () => {
        view.operators = Object.keys (operatorsMap).map (s => {
            return { ...operatorsMap[s] }
        });
        model.operators = view.operators.map (it => it.token_id).join(',')
    }

    const removeOperator = (event) => {
        if (operatorsMap[event.detail.id])
            delete operatorsMap[event.detail.id];

        toOpsList ();
        if (view.operators.length === 0)
            view.operators = viewDefaults.operators;

        view = view;
        model = model;
    }

    const onClientSelect = (event) => {
        const { detail } = event;
        console.log ('onClientSelect', detail)
        model.client = detail.id;
        view.client = detail.name;

        if (detail.address.length > 1) {
            areas = detail.address;
        } else
            areas = null;
    }

    const onAreaSelect = (event) => {
        const { detail } = event;
        console.log ('onAreaSelect', detail)
        model.data = JSON.stringify ({ address: detail });
        view.zone = detail.name + ' (' + detail.city + ')';
    }

    const onOperatorSelect = (event) => {
        const { detail } = event;

        operatorsMap[detail.token_id] = detail;

        toOpsList ();
        // if (view.operators.length === 0)
        //     view.operators = viewDefaults.operators;

        view = view;
        model = model;
        // console.log ('onOperatorSelect', detail)
    }

    const onWorkSelect = (event) => {
        const { detail } = event

        // console.log ('onWorkSelect', detail)
        model.description = detail.description;
        model = model;
    }

    const onDateSelect = (event) => {
        const { date } = event.detail;
        // console.log ('onDateSelect', date)
        // dateValue = date;
        model.date = date.getTime ();
        dateString = moment(date).format ('dddd DD/MM/YYYY HH:mm')
    }

    const chooseDate = (event) => {
        listType = 'datepicker'
    }

    const listClients = (event) => {
        listType = 'clients'
    }

    const listAreas = (event) => {
        listType = 'areas'
    }

    const listWorks = (event) => {
        listType = 'works'
    }

    $: changed = initialModel !== JSON.stringify (model);

    $: editor = data && users ? (data.editedby ? users[data.editedby] : users[data.creator]) : null;

    $: if (data) {
        loadData (data)
    }
</script>

<ModalOverlay />
{#if data || create}
    <Modal classes="ProgramEditor" hideOverlay>
        <SideListEditorLayout title={create ? 'Nuovo Programma' : data.client_data.name}>
            <ListField name="date" value={dateString} on:list={chooseDate} />
            <ListField name="client" value={view.client} placeholder="Scegli cliente" valid={validFields.client} 
                on:list={listClients} />
            {#if areas}
                <ListField name="area" value={view.zone} 
                    on:list={listAreas} />
            {/if}
            <SmartField name="description" label="Descrizione" bind:value={model.description} 
                type="textarea" on:clicked={listWorks} />
            <ListField name="operators" value={view.operators} placeholder="Scegli operatore/i" valid={validFields.operators} 
                on:remove={removeOperator} 
                on:list={e => { listType = 'operators' }} />
            <SmartSelect name="type" bind:value={model.type} options={types} legacy />
            <SmartField name="notes" label="Note" bind:value={model.notes} type="textarea" />
            
            {#if editor}
                <div class="text-xs">
                    Ultima modifica di: <span class="font-bold">{editor.name}</span>
                </div>
            {/if}

            <div slot="list">
                {#if listType === 'clients'}
                    <ListClients on:select={onClientSelect} on:app-event />
                {:else if listType === 'operators'}
                    <ListOperators sectorId={$userStore.sector.id} date={model.date} on:select={onOperatorSelect} on:app-event />
                {:else if listType === 'works'}
                    <ListWorks on:select={onWorkSelect} on:app-event />
                {:else if listType === 'areas'}
                    <ListAreas items={areas} on:select={onAreaSelect} on:app-event />
                {:else if listType === 'datepicker'}
                    <ChooseDate value={dateValue} on:datepicked={onDateSelect} />
                {/if}
            </div>
            <div slot="buttons">
                {#if changed}
                    <button class="btn btn-sm btn-primary" disabled={ctrlsDisabled} on:click={save}>Salva Modifiche</button>
                {/if}
                <button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={cancel}>Annulla</button>
            </div>
        </SideListEditorLayout>
    </Modal>
{/if}


<style>
    
</style>